/**
 * Constants File (Legacy)
 * Re-exports from new constants location for backward compatibility
 * @deprecated Use 'app/core/constants' instead
 */

// Import first (ESLint requirement)
import { PERMISSIONS, LAYOUT, COLORS, LEAVE_TYPES, LEAVE_DAYS } from '../core/constants';

// Re-export from new location
export * from '../core/constants';

// Legacy exports for backward compatibility

// Individual exports for backward compatibility
export const topBarHeight = LAYOUT.TOP_BAR_HEIGHT;
export const sideNavWidth = LAYOUT.SIDE_NAV_WIDTH;
export const navbarHeight = LAYOUT.NAVBAR_HEIGHT;
export const sidenavCompactWidth = LAYOUT.SIDENAV_COMPACT_WIDTH;
export const containedLayoutWidth = LAYOUT.CONTAINED_LAYOUT_WIDTH;

// Settings & Admin
export const ROLE_PERMISSION = PERMISSIONS.ROLE_PERMISSION;
export const PERMISSION = PERMISSIONS.PERMISSION;
export const USERS = PERMISSIONS.USERS;
export const WORKLOCATION = PERMISSIONS.WORKLOCATION;
export const HOLIDAYS = PERMISSIONS.HOLIDAYS;
export const HIERARCHY = PERMISSIONS.HIERARCHY;

// Product/Inventory
export const CATEGORY = PERMISSIONS.CATEGORY;
export const UNIT = PERMISSIONS.UNIT;
export const PRODUCT = PERMISSIONS.PRODUCT;

// Leave & Attendance
export const LEAVE_POLICY = PERMISSIONS.LEAVE_POLICY;
export const PENDING_LEAVE_REQUEST = PERMISSIONS.PENDING_LEAVE_REQUEST;
export const ATTENDANCE = PERMISSIONS.ATTENDANCE;

// Reports
export const HRREPORT = PERMISSIONS.HRREPORT;
export const REPORTS = PERMISSIONS.REPORTS;
export const FINANCIAL_REPORTS = PERMISSIONS.FINANCIAL_REPORTS;

// Project & Task Management
export const CRM = PERMISSIONS.CRM;
export const CLIENTMANAGMENT = PERMISSIONS.CLIENTMANAGMENT;
export const PROJECTMANAGMENT = PERMISSIONS.PROJECTMANAGMENT;
export const TASKLIST = PERMISSIONS.TASKLIST;
export const NEWTASK = PERMISSIONS.NEWTASK;
export const PROJECTTASK = PERMISSIONS.PROJECTTASK;
export const ADDPROJECT = PERMISSIONS.ADDPROJECT;
export const PROJECTLIST = PERMISSIONS.PROJECTLIST;
export const MYTASK = PERMISSIONS.MYTASK;
export const TASKSTATUS = PERMISSIONS.TASKSTATUS;

// Communication
export const CHAT = PERMISSIONS.CHAT;

// Dashboard & Analytics
export const DASHBOARD = PERMISSIONS.DASHBOARD;
export const ANALYTICS = PERMISSIONS.ANALYTICS;

// Financial & Payroll
export const PAYROLL = PERMISSIONS.PAYROLL;

// Calendar & Scheduling
export const CALENDAR = PERMISSIONS.CALENDAR;

// Integrations
export const INTEGRATIONS = PERMISSIONS.INTEGRATIONS;

export const ColorCode = COLORS.CODE;
export const leaveType = LEAVE_TYPES;
export const leaveDay = LEAVE_DAYS;
